const store = {
    namespaced: true,
    state: {
        current_identity: "",
    },
    actions: {
    },
    mutations: {
    }
}

export default store
